(() => {
  if (!customElements.get('page-navigation')) {
    class PageNavigation extends HTMLElement {
      connectedCallback() {
        this.setProperties();
        this.scrollActiveItem();
      }

      setProperties() {
        this.activeLink = this.querySelector('[data-page-navigation-active]');
        this.mobileMediaQuery = window.matchMedia('(max-width: 999px)');
      }

      scrollActiveItem() {
        if (!this.activeLink || !this.mobileMediaQuery.matches) {
          return;
        }

        requestAnimationFrame(() => {
          this.activeLink.scrollIntoView({
            block: 'nearest',
            inline: 'start',
            behavior: 'auto'
          });
        });
      }
    }

    customElements.define('page-navigation', PageNavigation);
  }
})();
